export function determineOrbCandleDuration(setupDetails) {
  return setupDetails.candleDuration;
}